var _jsxFileName = "/Users/pjreed/dev/mirador/dist/es/src/components/BackgroundPluginArea.js";
import React from 'react';
import ns from '../config/css-ns';
import { PluginHook } from './PluginHook';
/** invisible area where background plugins can add to */

export var BackgroundPluginArea = function BackgroundPluginArea(props) {
  return React.createElement("div", {
    className: ns('background-plugin-area'),
    style: {
      display: 'none'
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: this
  }, React.createElement(PluginHook, Object.assign({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    },
    __self: this
  })));
};
BackgroundPluginArea.defaultProps = {
  PluginComponents: []
};